import { Injectable } from "@angular/core";
import { attemptAsync } from "es-toolkit";
import { BehaviorSubject } from "rxjs";

export enum LocalNetworkAccessQueryResult {
  GRANTED = "granted",
  DENIED = "denied",
  PROMPT = "prompt",
  NOT_FOUND = "not-found"
}

@Injectable()
export class LocalNetworkAccessService {
  readonly #changeSubject = new BehaviorSubject<LocalNetworkAccessQueryResult>(
    LocalNetworkAccessQueryResult.NOT_FOUND
  );
  readonly change$ = this.#changeSubject.asObservable();

  #permissionQueryResult: PermissionStatus | null = null;

  async query(): Promise<LocalNetworkAccessQueryResult> {
    if (this.#permissionQueryResult) {
      this.#permissionQueryResult.onchange = null;
      this.#permissionQueryResult = null;
    }

    const [error, permissionQueryResult] = await attemptAsync(() =>
      navigator.permissions.query({
        name: <PermissionName>"local-network-access"
      })
    );

    switch (true) {
      case !!error || !permissionQueryResult: {
        return LocalNetworkAccessQueryResult.NOT_FOUND;
      }
      default: {
        this.#permissionQueryResult = permissionQueryResult;
        this.#permissionQueryResult.onchange = () => {
          this.#changeSubject.next(
            this.#mapPermissionQueryToQueryResult({
              state: permissionQueryResult.state
            })
          );
        };

        return this.#mapPermissionQueryToQueryResult({
          state: permissionQueryResult.state
        });
      }
    }
  }

  #mapPermissionQueryToQueryResult({
    state
  }: {
    state: PermissionState;
  }): LocalNetworkAccessQueryResult {
    switch (state) {
      case "denied": {
        return LocalNetworkAccessQueryResult.DENIED;
      }
      case "granted": {
        return LocalNetworkAccessQueryResult.GRANTED;
      }
      case "prompt": {
        return LocalNetworkAccessQueryResult.PROMPT;
      }
    }
  }
}
